<template>
  <div class="table-card">
    <div class="table-header-box">
      <div class="title-left">
        <i class="far fa-file-alt header-icon"></i>
        <div>
          <h3 class="card-title">Thống kê truy cập chi tiết</h3>
          <p class="card-subtitle">
            Danh sách trang có hoạt động cao nhất trong {{ rangeLabel }} (Tối đa 20 trang)
          </p>
        </div>
      </div>

      <div class="toggle-right">
        <div class="pill-group">
          <button
            class="pill-btn"
            :class="{ active: activeTab === 'page' }"
            @click="activeTab = 'page'"
          >
            Lượt xem trang
          </button>
          <button
            class="pill-btn"
            :class="{ active: activeTab === 'qr' }"
            @click="activeTab = 'qr'"
          >
            Lượt quét QR
          </button>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <table class="custom-analytics-table">
        <thead>
          <tr>
            <th class="col-title">
              {{ isPathView ? 'Đường dẫn trang (Path)' : 'Tiêu đề trang (Page Title)' }}
            </th>
            <th class="col-count text-right">
              {{ activeTab === 'page' ? 'Lượt xem (Views)' : 'Lượt quét (Scans)' }}
            </th>
            <th class="col-ratio text-right">
              {{ activeTab === 'page' ? 'Tỷ lệ xem' : 'Tỷ lệ quét' }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="currentRows && currentRows.length > 0">
            <tr v-for="(row, idx) in currentRows" :key="idx">
              <td class="col-title">
                <div class="page-info">
                  <i class="far fa-file-alt item-icon"></i>
                  <span class="page-text">{{ row.title || row.path }}</span>
                  <a
                    v-if="row.path && row.path.startsWith('/')"
                    :href="row.path"
                    target="_blank"
                    class="ext-link"
                    title="Mở đường dẫn"
                  >
                    <i class="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </td>
              <td class="col-count text-right bold-num">
                {{ row.views !== undefined ? row.views : (row.scans || 0) }}
              </td>
              <td class="col-ratio text-right">
                <div class="progress-box">
                  <div class="bar-outer">
                    <div
                      class="bar-inner"
                      :style="{ width: Math.min(row.percentage || 0, 100) + '%' }"
                    ></div>
                  </div>
                  <span class="pct-text">{{ row.percentage || 0 }}%</span>
                </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="3" class="text-center empty-cell">
                <el-empty description="Chưa có dữ liệu thống kê"></el-empty>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageStatsTable',
  props: {
    pageStats: {
      type: Array,
      default: () => []
    },
    qrStats: {
      type: Array,
      default: () => []
    },
    rangeLabel: {
      type: String,
      default: '30 phút qua'
    }
  },
  data() {
    return {
      activeTab: 'page' // 'page' | 'qr'
    }
  },
  computed: {
    currentRows() {
      if (this.activeTab === 'qr') {
        return this.qrStats && this.qrStats.length > 0 ? this.qrStats : []
      }
      return this.pageStats && this.pageStats.length > 0 ? this.pageStats : []
    },
    isPathView() {
      if (!this.currentRows || this.currentRows.length === 0) return false
      const firstRow = this.currentRows[0] || null
      const sample = firstRow ? (firstRow.path || firstRow.title || '') : ''
      return sample.startsWith('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.table-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f3f5;
  margin-bottom: 30px;

  .table-header-box {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 16px;

    .title-left {
      display: flex;
      align-items: flex-start;
      gap: 10px;

      .header-icon {
        font-size: 16px;
        color: #d97706;
        margin-top: 3px;
      }

      .card-title {
        font-size: 16px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
      }

      .card-subtitle {
        font-size: 13px;
        color: #6b7280;
        margin: 4px 0 0 0;
      }
    }

    .pill-group {
      background: #fdfbf7;
      border: 1px solid #eef0f3;
      padding: 3px;
      border-radius: 20px;
      display: flex;
      gap: 4px;

      .pill-btn {
        background: transparent;
        border: none;
        border-radius: 16px;
        padding: 6px 16px;
        font-size: 13px;
        font-weight: 600;
        color: #6b7280;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          color: #111827;
        }

        &.active {
          background: #ffffff;
          color: #111827;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
        }
      }
    }
  }

  .table-wrapper {
    overflow-x: auto;
  }

  .custom-analytics-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    th {
      text-align: left;
      padding: 12px 16px;
      font-weight: 700;
      color: #374151;
      border-bottom: 1px solid #e5e7eb;
      font-size: 13px;
    }

    td {
      padding: 14px 16px;
      border-bottom: 1px solid #f3f4f6;
      color: #1f2937;
    }

    tr:last-child td {
      border-bottom: none;
    }

    .col-title {
      width: 55%;
    }

    .col-count {
      width: 20%;
    }

    .col-ratio {
      width: 25%;
    }

    .text-right {
      text-align: right;
    }

    .bold-num {
      font-weight: 700;
      color: #111827;
    }

    .page-info {
      display: flex;
      align-items: center;
      gap: 8px;

      .item-icon {
        color: #9ca3af;
        font-size: 14px;
      }

      .page-text {
        font-weight: 500;
        color: #111827;
      }

      .ext-link {
        color: #9ca3af;
        font-size: 11px;
        margin-left: 2px;
        transition: color 0.15s ease;

        &:hover {
          color: #3b82f6;
        }
      }
    }

    .progress-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;

      .bar-outer {
        width: 100px;
        height: 6px;
        background: #f3f4f6;
        border-radius: 3px;
        overflow: hidden;

        .bar-inner {
          height: 100%;
          background: #f59e0b;
          border-radius: 3px;
        }
      }

      .pct-text {
        font-size: 13px;
        font-weight: 600;
        color: #4b5563;
        min-width: 45px;
        text-align: right;
      }
    }

    .empty-cell {
      padding: 40px 0;
    }
  }
}
</style>
